import { useQueryClient } from '@tanstack/vue-query';
import type { RouteLocationNormalized } from 'vue-router';

import { type Profile, profileKeys } from '@/entities/profile';
import { projectKeys, projectQueryOptions } from '@/entities/project';
import { IS_BILLING_ENABLED } from '@/shared/config';

export async function dashboardGuard(to: RouteLocationNormalized) {
  const queryClient = useQueryClient();
  const currentProjectUuid = to.params.project_uuid as string | undefined;
  const profile = queryClient.getQueryData<Profile>(profileKeys.profile());

  const isUserVerified = IS_BILLING_ENABLED ? profile?.is_verified : true;
  const isUserSettled = profile?.is_email_confirmed && isUserVerified;
  const isUserMember = profile?.is_member && profile.is_email_confirmed;
  const isUserOnboarded = isUserSettled || isUserMember;

  if (!isUserOnboarded) {
    return {
      name: 'onboarding',
    };
  }

  try {
    const project = await queryClient.ensureQueryData({
      ...projectQueryOptions(currentProjectUuid ?? 'default'),
      gcTime: Infinity,
      staleTime: Infinity,
    });

    queryClient.setQueryData(projectKeys.project(project.uuid), project);

    if (to.fullPath === '/') {
      return {
        name: 'project',
        params: { project_uuid: project.uuid },
      };
    }
  } catch {
    return {
      name: '500',
    };
  }
}
